var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/rejectreason-new.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-afa07212!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/rejectreason-new.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RejectReasonNew.vue
// module id = 701
// module chunks = 1